import { render, staticRenderFns } from "./QuantumLeap.vue?vue&type=template&id=76a135e9&scoped=true"
import script from "./QuantumLeap.vue?vue&type=script&lang=js"
export * from "./QuantumLeap.vue?vue&type=script&lang=js"
import style0 from "./QuantumLeap.vue?vue&type=style&index=0&id=76a135e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a135e9",
  null
  
)

export default component.exports